import CT from '@marketplace-ai/tags';
import { ColDef } from 'ag-grid-community';
import { ACTIONS_COLUMN_BASE, ActionsRenderer, type ActionDef } from '~/components/Table/gridUtil';

export const emptyForm = {
  aoiSelect: {
    value: '',
    label: '',
    category: '',
    description: '',
    specialtyName: '',
  },
  specSelect: { label: '', value: '' },
};

export const CreateAoiColumns = ({
  handleDelete,
}: {
  handleDelete: (id: number) => void;
}): ColDef[] => [
  { field: 'id', hide: true },
  { field: 'aoiName', headerName: 'Area' },
  { field: 'specialtyName', headerName: 'Specialty' },

  {
    // [MCV-1849] ActionsRenderer, like the other vault grids: DeleteCellRenderer
    // on its own fills the cell and centres its icon, so the right-aligned base
    // could not move it under the right-aligned header. The old width of 50 was
    // below the base's minWidth of 90, so 90 is what rendered anyway.
    ...ACTIONS_COLUMN_BASE,
    width: 90,
    cellRenderer: ActionsRenderer,
    cellRendererParams: {
      actions: [
        { type: 'delete', handler: handleDelete, cyTag: CT.privileges.table.deleteBtn },
      ] satisfies ActionDef[],
    },
  },
];
